module.exports = __webpack_public_path__ + "static/media/r_itdot_18.e270ca10.png";